import { render } from "./UpsellAddOnOption.vue?vue&type=template&id=577caae2"
import script from "./UpsellAddOnOption.vue?vue&type=script&lang=js"
export * from "./UpsellAddOnOption.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__